module.exports = __webpack_public_path__ + "media/images/front/treatment_support/banner_amazon-gift-card-3e71b7f31f3d3576c76348bb363a19f2.png";